var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding":"0 32px"},attrs:{"brezel-component-id":_vm.component.id}},[_c('a-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }